import { useEffect } from "react";
import DefaultPage from "pages/container/DefaultPage";
import { CircularProgress, Stack } from "@mui/joy";
import useLoginV3 from "./useLoginV3";
import { decodeJWT } from "utils/jwtUtils";

export default function AppleLoginRedirectV3() {
  const hashParams = window.location.hash.substring(1).split("&");
  const idTokenParam = hashParams.find((param) =>
    param.startsWith("id_token=")
  );
  const idToken = idTokenParam ? idTokenParam.split("=")[1] : null;

  // Decode JWT to extract email
  const decodedToken = idToken ? decodeJWT(idToken) : null;
  const email = decodedToken?.email || undefined;

  const { login } = useLoginV3({
    url: `/user/v2/login`,
    idToken: idToken!!,
    type: "apple",
    email: email,
  });

  useEffect(() => {
    if (idToken) {
      login();
    }
  }, [idToken]);

  return (
    <DefaultPage
      content={
        <Stack alignItems={"center"}>
          <CircularProgress color="neutral" />
        </Stack>
      }
    />
  );
}
